import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, CardBody, CardHeader, Table, Spinner, Badge } from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { toast } from "react-toastify";
import { getUsersApi } from "../../../apiServices/adminWork.services";

const UsersList = ({ search, role, setMode,hasPermission, setSelectedUser,setPermissionModal, setModal,setLoginModal, refresh, departmentId, designationId }) => {
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [hoveredRow, setHoveredRow] = useState(null);
  const [page,setPage]=useState(1);
  const [pagination,setPagination]=useState({
    total:0,
    page:1,
    totalPages:1,
    limit:10,
  });
  const fetchUsers = async () => {
    try {
      setLoading(true);
      const res = await getUsersApi({ search, role, departmentId, designationId, page, });
      setUsers(res?.data?.users || []);
      setPagination( res?.data?.pagination || { total:0, page:1, totalPages:1, limit:10, } );
    } catch (error) {
      toast.error("Failed to fetch users");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [ search, role, refresh, departmentId, designationId, page, ]);
  useEffect(() => {
    setPage(1);
  }, [search, role, departmentId, designationId]);
  const getRoleBadge = (role) => {
    switch (role) {
      case "super_admin":
        return <Badge color="danger">Super Admin</Badge>;
      case "admin":
        return <Badge color="primary">Admin</Badge>;
      default:
        return <Badge color="secondary">Employee</Badge>;
    }
  };

  const getStatusBadge = (user) => {
    if (!user || !user.isActive) {
      return <Badge color="dark">Inactive</Badge>;
    }
    const status = (user?.employeeStatus || "active").toLowerCase();
    switch (status) {
      case "terminated":
        return <Badge color="danger">Terminated</Badge>;
      case "resigned":
        return <Badge color="secondary">Resigned</Badge>;
      case "leave":
        return <Badge color="warning" className="text-dark">On Leave</Badge>;
      case "security":
        return <Badge color="info">Security Hold</Badge>;
      case "active":
      default:
        return <Badge color="success">Active</Badge>;
    }
  };

  return (
    <div>

      <Container fluid className="px-0 px-md-2">
        <Row>
          <Col lg={12} className="px-0 px-md-2">
            <Card className="shadow-sm border-0">
              {/* <CardHeader className="bg-light d-flex justify-content-between align-items-center">
                <h4 className="mb-0 text-primary">
                  <i className="mdi mdi-account-group me-2"></i>
                  Users
                </h4>
              </CardHeader> */} 

              <CardBody>
                {loading ? (
                  <div className="text-center py-5">
                    <Spinner />
                  </div>
                ) : (
                  <div className="table-responsive" style={{overflowX:"auto", WebkitOverflowScrolling:"touch"}}>
                    <Table className="align-middle table-nowrap mb-0">
                      <thead className="table-light">
                        <tr>
                          <th className="text-center" style={{maxWidth:"30px"}}>#</th>
                          <th>User</th>
                          {/* <th>Contact</th> */}
                          
                          <th>Status</th>
                          {/* <th>Department</th> */}
                          <th>Actions</th>
                        </tr>
                      </thead>

                      <tbody>
                        {users.length > 0 ? (
                          users.map((user, index) => (
                            <tr key={user._id}  onMouseEnter={() => setHoveredRow(user._id)}
                                onMouseLeave={() => setHoveredRow(null)}>
                              <td
                                style={{minWidth:"55px"}}
                                className="position-relative text-center p-0"
                                onMouseEnter={() => setHoveredRow(user._id)}
                                onMouseLeave={() => setHoveredRow(null)}
                              >
                                {hoveredRow === user._id && hasPermission("Edit User") ?  (
                                  <button
                                    className="btn btn-sm btn-primary"
                                    onClick={() => {
                                      setMode("edit");
                                      setSelectedUser(user);
                                      setModal(true);
                                    }}
                                  >
                                    <i className="mdi mdi-pencil"></i>
                                  </button>
                                ) : (
                                  index + 1
                                )}
                              </td>

                              <td>
                                <div className="fw-semibold">
                                  {user.firstName} {user.lastName}
                                </div>

                                <small>{user.departmentId?.name}</small><br />

                                <small>{user.designationId?.title}</small><br />

                                <small>{user.email}</small><br />

                                <small>{user.mobile}</small>
                              </td>

                              {/* <td>{user.email}<br/>{user.mobile || "-"}</td> */}

                              <td >
                               {getStatusBadge(user)}
                              </td>

                              {/* <td>
                                
                              </td> */}

                              {/* <td>{getStatusBadge(user.isActive)}</td> */}
                              <td>
                                  <div className="d-flex flex-column flex-md-row gap-2">
                                    {hasPermission("Assign Manager") && (
                                        <i className="mdi mdi-account-supervisor text-primary cursor-pointer td-icon"
                                          onClick={() => {
                                            setMode("assignManager");
                                            setSelectedUser(user);
                                            setModal(true); }}
                                        ></i>
                                      )}
                                    {hasPermission("View Tree") && (
                                      <i
                                        className="text-info mdi mdi-file-tree cursor-pointer td-icon"
                                        onClick={() => {
                                          setMode("tree");
                                          setSelectedUser(user);
                                          setModal(true);
                                        }}
                                      ></i>
                                    )}
                                    {hasPermission("OverRide Permissions") && (
                                      <i
                                        className="mdi mdi-shield-account-outline text-warning cursor-pointer td-icon"
                                        onClick={()=>{
                                          setSelectedUser(user);
                                          setPermissionModal(true);
                                        }}
                                      ></i>
                                    )}
                                    {hasPermission("User Login Blockage") && (
                                      <i
                                        className="mdi mdi-key-outline text- cursor-pointer td-icon"
                                        onClick={()=>{
                                          setSelectedUser(user);
                                          setLoginModal(true);
                                        }}
                                      ></i>
                                    )}
                                    {hasPermission("Assign Manager", "View Tree", "OverRide Permissions","User Login Blockage") ? (
                                      <span className="d-none">|</span>
                                    ) : (
                                      <span className="text-muted">Ask Admin for permissions</span>
                                    )}
                                  </div>
                                </td>
                              {/* <td>
                                {new Date(user.createdAt).toLocaleDateString(
                                  "en-GB"
                                )}
                              </td> */}
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="8" className="text-center py-4">
                              No Users Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                    <div className="d-flex justify-content-end align-items-center gap-2 mt-3">
                      <button
                        className="btn btn-sm btn-light"
                        disabled={page <= 1}
                        onClick={() => setPage(prev => prev - 1)}
                      >
                        <i className="mdi mdi-chevron-left" />
                      </button>

                      <span className="small">
                        Page {pagination.page} of {pagination.totalPages}
                      </span>

                      <button
                        className="btn btn-sm btn-light"
                        disabled={page >= pagination.totalPages}
                        onClick={() => setPage(prev => prev + 1)}
                      >
                        <i className="mdi mdi-chevron-right" />
                      </button>

                    </div>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default UsersList;